"use client";

import { useEffect } from "react";
import {
  useWebInfoDetail,
  useWebInfoSave,
} from "../../../hooks/api/web-info/hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import toast from "react-hot-toast";
import { Form, Input, Button } from "antd";
import { WebInfoType } from "@src/types/api/webInfo";

// ---------------- Validation ----------------
const schema = yup.object({
  phone: yup.string().required("Phone is required"),
  email: yup.string().email("Invalid Email").required("Email is required"),
  address: yup.string().required("Address is required"),
});

type WebInfoFormType = yup.InferType<typeof schema>;

const SupportAndHelp = ({ type }: { type: WebInfoType }) => {
  const { data: details } = useWebInfoDetail(type);

  const { mutate: saveForm, isPending } = useWebInfoSave({
    onSuccess: () => toast.success("Saved successfully"),
    onError: (error: any) =>
      toast.error(error?.message || "Something went wrong"),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<WebInfoFormType>({
    resolver: yupResolver(schema),
    defaultValues: {
      phone: "",
      email: "",
      address: "",
    },
  });

  // ---------------- Prefill (Edit mode) ----------------
  useEffect(() => {
    if (details?.data) {
      reset(details?.data?.support);
    }
  }, [details?.data, reset]);

  // ---------------- Submit ----------------
  const onSubmit = (values: WebInfoFormType) => {
    let payload = {
      type,
      support: {
        phone: values.phone,
        email: values.email,
        address: values.address,
      },
      ...(details?.data?._id && { _id: details.data._id }),
    };
    saveForm(payload);
  };

  return (
    <div className="w-full mx-auto">
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        <div className="p-6 bg-[#fdf0e3] rounded-xl">
          {/* PHONE */}
          <Form.Item
            label="Phone"
            validateStatus={errors.phone ? "error" : ""}
            help={errors.phone?.message}
          >
            <Controller
              name="phone"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  type="number"
                  placeholder="Enter phone number"
                />
              )}
            />
          </Form.Item>

          {/* EMAIL */}
          <Form.Item
            label="Email"
            validateStatus={errors.email ? "error" : ""}
            help={errors.email?.message}
          >
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="Enter email" />
              )}
            />
          </Form.Item>

          {/* ADDRESS */}
          <Form.Item
            label="Address"
            validateStatus={errors.address ? "error" : ""}
            help={errors.address?.message}
          >
            <Controller
              name="address"
              control={control}
              render={({ field }) => (
                <Input.TextArea
                  {...field}
                  placeholder="Enter address"
                  rows={3}
                />
              )}
            />
          </Form.Item>
        </div>

        {/* BUTTON */}
        <div className="mt-6 flex justify-start">
          <Button
            type="primary"
            htmlType="submit"
            loading={isPending}
            className="bg-primary px-10"
          >
            {isPending ? "Saving..." : "Save"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default SupportAndHelp;
